import { z } from "zod";
export const SystemTagSchema = z.enum([
    "LEAD",
    "CUSTOMER",
    "CRAFTSMAN",
    "SUPPLIER",
    "MANUFACTURER",
    "SUBCONTRACTOR",
]);
//# sourceMappingURL=tags.js.map